import * as React from 'react'
import 'react-dates/initialize'
import styled, { AnyStyledComponent } from 'styled-components'
import I18n from '../../../../core/i18n'
import { utilService } from '../../../../core/services'
import * as constants from '../../../../static/constants'
import * as interfaces from '../../../../static/interfaces'
import Typography from 'components/atoms/_layouts/Typography'
const ReceiptPreview: React.VFC<{ receipt: interfaces.IReceipt }> = ({ receipt }) => {
  return (
    <S.ReceiptPreview id="ReceiptPreview">
      <div className="head">
        <div className="head_company">
          <img className="receipt_logo" src="/images/custom/logo_pdf.jpg" />
          <div className="company_info">
            <Typography type="headline">Compass Corp.</Typography>
            <Typography type="body" size="xl">
              {I18n.t('company.address')}
            </Typography>
          </div>
        </div>
        <div className="title">
          <Typography type="headline" size="lg">
            {I18n.t('generic.receipt')}
          </Typography>
        </div>
        <div className="right">No.{receipt.no}</div>
      </div>

      <div className="section">
        <div className="label">{I18n.t('receipt.receipt_address')}</div>
        <div className="value bold">{I18n.t('generic.to_user', { username: receipt.name })}</div>
      </div>
      <div className="section">
        <div className="label">{I18n.t('payments.pay_amount')}</div>
        <div className="value bold">{utilService.formatPrice(receipt.payment_amount)}</div>
      </div>
      <div className="section">
        <div className="label">{I18n.t('payments.paid_at')}</div>
        <div className="value">
          {utilService.formatDateFromLocale(receipt.payment_date, I18n.locale, 'YYYY/MM/DD')}
        </div>
      </div>
      <div className="section">
        <div className="label">{I18n.t('payments.payment_method')}</div>
        <div className="value">{receipt.payment_method}</div>
      </div>
      <div className="subtitle">
        <Typography type="subtitle" size="xl">
          {I18n.t('reservation.detail')}
        </Typography>
      </div>
      <div className="section">
        <div className="label">{I18n.t('post.post_name')}</div>
        <div className="value">{receipt.tour_name}</div>
      </div>
      <div className="section">
        <div className="label">{I18n.t('reservation.reservation_no')}</div>
        <div className="value">{receipt.reservation_no}</div>
      </div>
      <div className="section">
        <div className="label">{I18n.t('generic.participants')}</div>
        <div className="value">{receipt.guest_name}</div>
      </div>

      <div className="section">
        <div className="label">{I18n.t('payments.tour_date')}</div>

        <div className="value">
          {utilService.formatDateFromLocale(receipt.tour_date, I18n.locale, 'YYYY/MM/DD')}
        </div>
      </div>
    </S.ReceiptPreview>
  )
}
const S: { [key: string]: AnyStyledComponent } = {}

S.ReceiptPreview = styled.div`
  min-width: 680px;
  padding: 20px;
  .head {
    .title {
      text-align: center;
    }
    .right {
      text-align: right;
    }
    padding: 8px;
  }
  .head_company {
    display: flex;
    align-items: flex-end;
    margin-bottom: 32px;
    .receipt_logo,
    .company_info {
      width: 50%;
    }
    .company_info {
      padding: 6px 0;
    }
  }
  .subtitle {
    padding: 8px 0;
    text-align: center;
  }
  > .section {
    display: flex;
    align-items: center;

    .label {
      width: 180px;
      font-size: 16px;
      font-weight: 700;
      background: ${constants.COLORS.background};
      color: ${constants.COLORS.black};
      padding: 8px;
    }
    .value {
      width: calc(100% - 180px);
      margin-left: 16px;
    }
    .bold {
      font-size: 18px;
      font-weight: 700;
    }
  }
`
export default ReceiptPreview
